import storeService from '../api/services/storeService'
import {
  FETCHING_PRODUCT,
  FETCHING_PRODUCT_FINISHED,
  SET_ACTIVE_PRODUCT
} from './const'
import Product from 'api/models/Product'

function fetchProduct(storeId: string, productId: string, ct: any = null) {
  return function (dispatch: any) {
    dispatch(fetchingProduct())
    return storeService.getProduct(storeId, productId, ct)
      .then(product => new Product({...product}))
      .then(product => {
        dispatch(setActiveProduct(product))
        dispatch(fetchingProductFinished())
        return product;
      })
      .catch(error => {
        throw error;
      })
  }
}

function setActiveProduct(product: Product) {
  return {
    type: SET_ACTIVE_PRODUCT,
    product: product
  }
}

function fetchingProduct() {
  return {
    type: FETCHING_PRODUCT
  }
}

function fetchingProductFinished() {
  return {
    type: FETCHING_PRODUCT_FINISHED
  }
}
export {
  fetchProduct,
  setActiveProduct,
  fetchingProduct,
  fetchingProductFinished
}
